import { createSlice } from "@reduxjs/toolkit";

const getInitialCart = () => {
  try {
    return JSON.parse(localStorage.getItem("cart")) || [];
  } catch {
    return [];
  }
};

const persistCart = (cart) => {
  try {
    localStorage.setItem("cart", JSON.stringify(cart));
  } catch {
    // ignore storage errors
  }
};

const cartSlice = createSlice({
  name: "cart",
  initialState: getInitialCart(),
  reducers: {
    setCart: (state, action) => {
      const next = Array.isArray(action.payload) ? action.payload : [];
      persistCart(next);
      return next;
    },
    addItem: (state, action) => {
      const next = [...state, action.payload];
      persistCart(next);
      return next;
    },
    removeItem: (state, action) => {
      const next = state.filter((item) => item.id !== action.payload);
      persistCart(next);
      return next;
    },
    clearCart: () => {
      persistCart([]);
      return [];
    }
  }
});

export const { setCart, addItem, removeItem, clearCart } = cartSlice.actions;
export default cartSlice.reducer;
